import { EventEmitter } from '@angular/core';


export interface PlatformPortalApiModelsUserSettings {
  userId?: string;
  settingsJson?: string;
}

export class UserSettings implements PlatformPortalApiModelsUserSettings {
  userId?: string;
  settingsJson?: string;
  private _settings: any;

  // Event emitter for changes
  readonly onChange = new EventEmitter<void>();

  constructor(settings: PlatformPortalApiModelsUserSettings) {
    this.userId = settings.userId;
    this.settingsJson = settings.settingsJson;
    this._settings = JSON.parse(this.settingsJson ?? '{}');
  }

  get settings(): any {
    return this._settings;
  }

  set settings(value: any) {
    this._settings = value;
    this.updateJsonAndNotify();
  }

  getSetting<T>(key: string, defaultValue?: T): T | undefined {
    return this._settings?.[key] ?? defaultValue;
  }

  setSetting<T>(key: string, value: T): void {
    this._settings = { ...this._settings, [key]: value };
    this.updateJsonAndNotify();
  }

  removeSetting(key: string): void {
    const newSettings = { ...this._settings };
    delete newSettings[key];
    this._settings = newSettings;
    this.updateJsonAndNotify();
  }

  /**
   * Call this method after modifying nested properties of settings
   * Example: userSettings.settings.theme = 'dark'; userSettings.syncChanges();
   */
  syncChanges(): void {
    this.updateJsonAndNotify();
  }

  /**
   * Updates settingsJson from _settings and emits change event
   * @private
   */
  private updateJsonAndNotify(): void {
    this.settingsJson = JSON.stringify(this._settings);
    this.onChange.emit();
  }
}

